import { languages } from "../Data/languages";

// Short codes for a language pair ("SP → EN"), from the English names (Alejo,
// 2026-10-10): the first two letters of the name, Portuguese (both) as PT.
// Languages may share a code (Latin and Latvian are both LA): the full names
// are in the pair's title.

const BY_HAND = { portugueseBrazil: "PT", portuguesePortugal: "PT" };

const letters = (label) => String(label || "").replace(/\(.*\)/, "").replace(/[^A-Za-z]/g, "").toUpperCase();

export const CODES = {};
languages.forEach((l) => {
  CODES[l.value] = BY_HAND[l.value] || letters(l.label).slice(0, 2);
});

export const englishCode = (value, label = "") => CODES[value] || letters(label || value).slice(0, 2);
